import docReady from '../../../assets/js/docReady';
import registerCarModelDisplay from '../../shared/flamingoCarModelDisplay/flamingoCarModelDisplay';

docReady(() => {
    registerCarModelDisplay();
});
